export default __webpack_public_path__ + "static/media/Sunset-Edited-3840px-1176px.d7a2f15d.jpg";